module.exports = __webpack_public_path__ + "static/media/survey.0b671074.svg";